import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
/**
 * 登录跳转工具模块
 * 根据当前环境自动选择跳转到微信授权登录、手机号登录页或客户端APP登录
 */
import Fun from '@/fun/index';
import base64_encode from './base64_encode';
import base64_decode from './base64_decode';
import * as CommindSdk from "./commindSdk";
import { apiGetByAppLoginCode } from "@/api/pubilcApi";
/** sessionStorage 中存储 loginCode 的 key */
var LOGIN_CODE_KEY = 'commind_login_code';

/**
 * 生成不带横杠的 UUID
 * @returns {string} UUID 字符串（无 "-"）
 */
function generateUUID() {
  var d = Date.now();
  var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}

/**
 * 传播大脑客户端登录流程
 * 1. 生成 UUID 登录码并存储
 * 2. 跳转小程序进行登录
 * 3. 弹窗提示用户完成客户端登录
 * 4. 用户点击"已登录"后单次查询后端获取登录信息
 */
function startCommindAppLogin() {
  // 生成登录码并存储
  var code = generateUUID();
  sessionStorage.setItem(LOGIN_CODE_KEY, code);
  // 记录当前页面地址，登录成功后跳回
  sessionStorage.setItem("yz_redirect", base64_encode(document.location.href));

  // 跳转小程序登录页
  window.location.href = "https://vapp.tmuyun.com/openMiniProgram?originalId=gh_6234fa8f6b7d&path=" + encodeURIComponent('/pages/loginApp/loginApp?tid=' + Fun.getKey('tid') + "&mid=" + Fun.getKeyByMid() + "&appLoginCode=" + code);

  /** 登录成功后处理：存储 token 并跳转 */
  function handleLoginSuccess(res) {
    // 存储登录信息
    console.log("我在这里");
    if (res.data && res.data.token) {
      window.localStorage.setItem("access_token", res.data.token);
    }
    window.localStorage.setItem("isWxLogin", 0);
    // 清除临时 code
    sessionStorage.removeItem(LOGIN_CODE_KEY);
    // 跳转回原页面或首页
    var yzRedirect = sessionStorage.getItem("yz_redirect");
    console.log("yzRedirect", yzRedirect);
    console.log("Fun.getSiteRoot()", Fun.getSiteRoot());
    if (yzRedirect) {
      try {
        var targetUrl = base64_decode(yzRedirect);
        console.log("targetUrl", targetUrl);

        // 如果目标页与当前页一致，直接刷新即可（token 已写入 localStorage）
        if (targetUrl === window.location.href) {
          window.location.reload();
          console.log(window.location.href, 'console.log(window.location.href); ');
          return;
        }

        // 先尝试普通 href 跳转
        window.location.href = targetUrl;

        // 兜底：部分 APP WebView 会拦截异步回调里的 location 跳转，延迟再试
        setTimeout(function () {
          if (window.location.href !== targetUrl) {
            console.log("兜底 replace", targetUrl);
            window.location.replace(targetUrl);
          }
        }, 200);
      } catch (e) {
        console.error("跳转失败", e);
        window.location.href = Fun.getSiteRoot() + "#/";
      }
    } else {
      console.log("Fun.getSiteRoot()2", Fun.getSiteRoot());
      window.location.href = Fun.getSiteRoot() + "#/";
    }
  }

  // 弹出确认弹窗
  _Dialog.confirm({
    title: '登录提示',
    message: '请先在小程序完成登录，完成后点击"已登录"按钮',
    confirmButtonText: '已登录',
    cancelButtonText: '取消'
  }).then(function () {
    // 用户点击"已登录"，单次查询登录状态
    apiGetByAppLoginCode({
      code: code
    }).then(function (res) {
      if (res.code === 0 && res.data) {
        handleLoginSuccess(res);
      }
    });
  }).catch(function () {
    // 用户取消，清理code并刷新页面
    sessionStorage.removeItem(LOGIN_CODE_KEY);
    window.location.reload();
  });
}

/**
 * 根据当前环境跳转到对应的登录页面
 * - 微信/企业微信环境 → 微信授权登录页(AuthorizedLogin)
 * - 传播大脑客户端 → 客户端登录流程（弹窗 + 轮询获取token）
 * - 其他环境 → 手机号登录页(login)
 */
export function redirectToLogin() {
  var baseParams = "i=1&yz_redirect=" + base64_encode(document.location.href) + "&type=5&mid=" + Fun.getKeyByMid();
  if (Fun.isWeiXin() || Fun.isWXWork()) {
    // 微信/企业微信环境跳转到微信授权登录
    window.location.href = Fun.getSiteRoot() + "/#/AuthorizedLogin?" + baseParams + "&tid=" + Fun.getKey('tid');
  } else if (CommindSdk.isSdkAvailable()) {
    // 传播大脑融媒客户端环境：弹窗确认登录 + 轮询后端获取token
    startCommindAppLogin();
  } else {
    // 其他环境跳转到普通登录页
    window.location.href = Fun.getSiteRoot() + "/#/login?" + baseParams + "&tid=" + Fun.getKey('tid') + "&mid=" + Fun.getKeyByMid();
  }
}